import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Opt-out per il redirect globale di {@link Forbidden403Interceptor}.
 *
 * Le pagine che gestiscono in proprio il 403 (es. il wizard pratiche, l'eligibilità,
 * la vista pratiche, l'ISEE) renderizzano uno stato `forbidden` dedicato e devono
 * preservare i dati inseriti: per queste chiamate il redirect a `/pages/home` va
 * disattivato. L'interceptor continua comunque a propagare l'errore, così il
 * `catchError` della pagina può classificarlo.
 *
 * Default `false`: il comportamento generico (toast + redirect a home) resta attivo
 * per tutte le altre richieste.
 */
export const SKIP_FORBIDDEN_REDIRECT = new HttpContextToken<boolean>(() => false);

/**
 * Helper per costruire un `HttpContext` (o arricchirne uno esistente) che disattiva
 * il redirect globale sul 403. Da passare come `options.context` alle chiamate del
 * client generato.
 *
 * @example
 * this.catalogoBandi.getEligibilita({ slug, id }, 'body', false, { context: skipForbiddenRedirect() })
 */
export function skipForbiddenRedirect(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_FORBIDDEN_REDIRECT, true);
}
